<template>
	<div class="container">
		<div class="top-wrapper">
			<img class="top-img"
				:src="topImg" />
			<div class="name-box">
				<div class="name-sub">About Us</div>
				<div class="name-ch">关于我们</div>
			</div>
		</div>
		<div class="content-wrapper">
			<div class="center-section">
				<div class="section-top">
					<div class="section-title">
						关于我们
					</div>
					<div class="section-top-title-sub">
						我们成立于2024年，专注营养补充品出口与进口。供应商严选、品质把关、快速出货，是我们的承诺。
					</div>
				</div>
				<img class="center-img"
					:src="centerImg" />
			</div>
			<div class="feature-section">
				<div class="section-title">
					特色/Highlights
				</div>
				<div class="feature-box">
					<div class="feature-item"
						v-for="(item, index) in featureList"
						:key="index">
						<img class="feature-img"
							:src="item.url" />
						<div class="feature-name">{{item.title}}</div>
					</div>
				</div>
			</div>
		</div>
		<page-footer></page-footer>
	</div>
</template>

<script>
	import pageFooter from "@/components/common/page-footer/page-footer.vue"
	export default {
		name: 'home',
		components: {
			pageFooter
		},
		data() {
			return {
				topImg: require('@/assets/about1.png'),
				centerImg: require('@/assets/about2.png'),
				featureList: [{
						url: require('@/assets/about/item1.png'),
						title: "单一专注类别"
					},
					{
						url: require('@/assets/about/item2.png'),
						title: "品质验证"
					},
					{
						url: require('@/assets/about/item3.png'),
						title: "弹性出货"
					},
					{
						url: require('@/assets/about/item4.png'),
						title: "市场扩展"
					}
				]
			}
		}
	}
</script>

<style lang="scss"
	scoped>
	.container {
		text-align: left;
	}

	.top-wrapper {
		position: relative;

		.top-img {
			width: 100%;
			height: 1080px;
		}

		.name-box {
			position: absolute;
			top: 30%;
			transform: translateY(-50%);
			left: 10%;
			color: #fff;
			text-align: left;

			display: flex;
			flex-direction: column;
			display: inline;

			.name-sub {
				position: relative;
				font-size: 12px;
				text-align: left;
				padding: 0 16px;
				width: 50px;

				&::before {
					position: absolute;
					content: "";
					height: 1px;
					width: 15px;
					top: 50%;
					transform: translateY(-50%);
					left: -2px;
					background: #fff;
				}

				&::after {
					position: absolute;
					content: "";
					height: 1px;
					width: 15px;
					top: 50%;
					transform: translateY(-50%);
					right: -2px;
					background: #fff;
				}
			}

			.name-ch {
				margin-top: 10px;
				font-weight: bold;
				font-size: 26px;
			}
		}
	}

	.content-wrapper {
		width: 60%;
		margin: auto;
		margin-top: 30px;

		.center-section {
			color: #333;

			.section-top {
				display: flex;
				justify-content: space-between;


				.section-top-title-sub {
					font-size: 13px;
					line-height: 18px;
					max-width: 350px;
				}
			}

			.center-img {
				width: 100%;
				height: auto;
				margin-top: 30px;
			}
		}

		.feature-section {
			margin-top: 30px;

			.section-title {}

			.feature-box {
				display: flex;
				margin-top: 30px;

				.feature-item {
					margin-right: 10px;
					width: calc((100% - 30px) / 4);


					&:last-of-type {
						margin-right: 0;
					}

					.feature-img {
						width: 100%;
						height: 250px;
					}

					.feature-name {
						margin-top: 10px;
						font-size: 13px;
						color: #333;
					}
				}
			}
		}

	}

	.section-title {
		font-size: 28px;
		font-weight: bold;
		color: #333;
		position: relative;
		height: 30px;

		&:before {
			position: absolute;
			content: "";
			left: 0;
			width: 50px;
			height: 4px;
			background-color: #3E8CEF;
			bottom: -10px;
		}
	}
</style>